<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="asyncDataStatus_ready"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="canView" color="primary" small dark v-bind="attrs" v-on="on">
        Detalhes
      </v-btn>
    </template>

    <v-card flat tile class="fonte-gerenciamento">
      <v-toolbar tile flat dark color="primary">
        <v-toolbar-title>Lançamento de Fontes de Verificação</v-toolbar-title>
            <span v-if="lancamento.statusLancamento === 'ABERTO'"><v-chip class="ma-2" dark color="indigo">ABERTO</v-chip></span>
            <span v-if="lancamento.statusLancamento === 'AGUARDANDO_MONITORAMENTO'"><v-chip class="ma-2" color="info">AGUARDANDO MONITORAMENTO</v-chip></span>
            <span v-if="lancamento.statusLancamento === 'MONITORAMENTO_REALIZADO'"><v-chip class="ma-2" color="success">MONITORAMENTO REALIZADO</v-chip></span>
            <span v-if="lancamento.statusLancamento === 'AGUARDANDO_CORRECAO'"><v-chip class="ma-2 blue-grey--text" color="warning">AGUARDANDO CORREÇÕES</v-chip></span>
        <v-spacer></v-spacer>

        <v-btn v-if="lancamento.statusLancamento === 'ABERTO'" :loading="isFetching" @click="enviarParaMonitoramento" color="success">
          Enviar para Monitoramento
        </v-btn>
        <v-btn v-if="lancamento.statusLancamento === 'AGUARDANDO_CORRECAO'" :loading="isFetching" @click="enviarParaMonitoramento" class="blue-grey--text" color="warning">
          Enviar Correções para Monitoramento
        </v-btn>

        <v-btn v-if="canDeleteLancamento" @click="excluir()" icon dark>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <v-tabs color="primary">
              <v-tabs-slider></v-tabs-slider>
              <v-tab :href="`#tab-detalhes`" class="mr-5"> Detalhes </v-tab>
              <v-tab class="mr-5" :href="`#tab-upload`"> Upload de Arquivos </v-tab>
              <v-tab v-if="false" class="mr-5" :href="`#tab-arquivos-lancamento`"> Arquivos do Lançamento </v-tab>
              <v-tab v-if="false" :href="`#tab-lista-presenca`" class="mr-5"> Lista de Presença </v-tab>
              <v-tab v-if="indicador.relatoriaReuniaoEncontro" :href="`#tab-relatoria-reuniao-encontro`" class="mr-5">Relatoria de Reunião</v-tab>
              <v-tab v-if="indicador.planoOficinaIntercambioCaravana" :href="`#tab-plano-oficina-intercambio-caravana`" class="mr-5">Plano de Oficina Intercâmbio Caravana e Encontro</v-tab>
              <v-tab v-if="indicador.relatoriaOficinaIntercambioCaravana" :href="`#tab-relatoria-oficina-intercambio-caravana`" class="mr-5">Relatoria de Oficina Intercâmbio Caravana e Encontro</v-tab>
              <v-tab v-if="false" :href="`#tab-registro-fotografico-modelado`" class="mr-5">Registro Fotográfico Modelado</v-tab>
              <v-tab v-if="indicador.informeReuniao" :href="`#tab-informe-reuniao`" class="mr-5">Informe de Reunião</v-tab>

              <v-tab-item :value="'tab-detalhes'">
                <v-row >
                  <v-col cols="6">
                    <v-card elevation="0" tile>
                      <v-card-title >
                        <p>Detalhes</p>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-list>
                        <template v-if="impacto">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle
                                >{{
                                  impacto.posicaoFormatada
                                }}
                                Impacto</v-list-item-subtitle
                              >
                              <v-list-item-title class="text-wrap">{{
                                impacto.descricao
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                        <template v-if="realizacao">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle
                                >{{
                                  realizacao.posicaoFormatada
                                }}
                                Realização</v-list-item-subtitle
                              >
                              <v-list-item-title class="text-wrap">{{
                                realizacao.descricao
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                        <template v-if="produto">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle
                                >{{
                                  produto.posicaoFormatada
                                }}
                                Produto</v-list-item-subtitle
                              >
                              <v-list-item-title class="text-wrap">{{
                                produto.descricao
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                        <template v-if="atividade">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle
                                >{{
                                  atividade.posicaoFormatada
                                }}
                                Atividade</v-list-item-subtitle
                              >
                              <v-list-item-title class="text-wrap">{{
                                atividade.descricao
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle class="body-1">
                              <strong>{{ indicador.posicaoFormatada }} Indicador</strong>
                            </v-list-item-subtitle>
                            <v-list-item-title class="text-wrap body-1">
                              <strong class="">{{indicador.titulo}}</strong>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                      </v-list>
                    </v-card>

                    <v-card v-if="lancamento.statusLancamento === 'ABERTO'">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="text-h5">
                              Lançamento {{lancamento.descricao}}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-btn :loading="isFetching" @click="enviarParaMonitoramento" block x-large  color="success">
                            Enviar para Monitoramento
                          </v-btn>
                      </v-card-actions>
                    </v-card>

                    <v-card v-if="lancamento.statusLancamento === 'AGUARDANDO_CORRECAO'">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="text-h5">
                              Lançamento {{lancamento.descricao}}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>

                        <v-col cols="12" class="ml-1">
                          <span class="font-weight-bold text-uppercase">Observaçoes do Monitoramento:</span>
                          <p class="font-weight-light title ">
                            {{ lancamento.observacoesMonitoramento }}
                          </p>
                        </v-col>

                        <v-divider></v-divider>


                        <v-card-actions>
                          <v-btn :loading="isFetching" @click="enviarParaMonitoramento" block x-large  color="success">
                            Enviar Correções para Monitoramento
                          </v-btn>
                      </v-card-actions>
                    </v-card>

                    <template v-if="canEditMonitoramento">
                      <v-form @submit.prevent="salvar" lazy-validation v-model="valid" ref="form" v-if="lancamento.statusLancamento !== 'ABERTO'">
                        <v-card tile flat elevation="0">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="text-h5">
                                Monitoramento {{lancamento.descricao}}
                                <v-list-item-subtitle>
                                  <span class="font-weight-bold text-uppercase">Lançador por: {{lancamento.lancadoPor.nome}}</span>
                                </v-list-item-subtitle>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-card-text>
                            <v-autocomplete
                              v-model="responsavelId"
                              :items="participantes"
                              item-text="usuario.nome"
                              item-value="usuario.id"
                              label="Responsável"
                              rows="1"
                              :rules="[v => !!v || 'Responsável é obrigatório']"
                              auto-grow
                              filled
                            ></v-autocomplete>

                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="auto"
                              min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="dateFormatted"
                                  label="Data"
                                  hint="DD/MM/AAAA"
                                  append-icon="mdi-calendar"
                                  @blur="date = parseDate(dateFormatted)"
                                  :rules="[v => !!v || 'Data é obrigatória']"
                                  v-on="on"
                                  v-bind="attrs"
                                  persistent-hint
                                  filled
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="date"
                                no-title
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>

                            <v-select
                              label="Avaliação do Monitoramento"
                              v-model="statusLancamento"
                              :items="[
                                {value:'MONITORAMENTO_REALIZADO', text:'APROVADO'}, 
                                {value:'AGUARDANDO_CORRECAO', text:'SOLICITAÇÕES DE CORREÇÕES'}]"
                              :rules="[(v) => !!v || 'Avaliação é obrigatória.']"
                              filled
                              return-object
                            ></v-select>
                            
                            <v-textarea
                              v-model="observacoesMonitoramento"
                              label="Observaçoes do Monitoramento"
                              rows="1"
                              filled
                              auto-grow
                            ></v-textarea>

                            <div class="text-left" v-if="indicador.tipologia === 'CUMULATIVA'">
                              <v-chip class="text-right" color="success" label outlined>
                                Progresso atual: {{indicador.totalAtingido}} de {{ indicador.totalEsperado }}
                              </v-chip>
                            </div>

                            <div class="text-left" v-if="indicador.tipologia === 'PROGRESSIVA'">
                              <v-chip class="text-right" color="success" label outlined>
                                Progresso atual: {{indicador.totalAtingido}}% de {{ indicador.totalEsperado }}%
                              </v-chip>
                            </div>
                            <span class="font-weight-bold">{{lancamento.indicador.titulo}}</span>

                            <v-text-field
                              label="Progresso"
                              v-model="progresso"
                              :suffix="'TIPOLOGIA '+indicador.tipologia"
                              filled
                            ></v-text-field>

                            <template v-for="(item, index) in lancamentosFilhos">
                              <div :key="item.id">
                                <p v-if="0"> {{ this.lancamentoProgressos.push({'item': item.id}) }} </p>

                                <div class="text-left" v-if="item.indicador.tipologia === 'CUMULATIVA'">
                                  <v-chip class="text-right" color="success" label outlined>
                                    Progresso atual: {{item.indicador.totalAtingido}} de {{ item.indicador.totalEsperado }}
                                  </v-chip>
                                </div>

                                <div class="text-left" v-if="item.indicador.tipologia === 'PROGRESSIVA'">
                                  <v-chip class="text-right" color="success" label outlined>
                                    Progresso atual: {{item.indicador.totalAtingido}}% de {{ item.indicador.totalEsperado }}%
                                  </v-chip>
                                </div>
                                <span class="font-weight-bold">{{item.indicador.titulo}}</span>

                                <v-text-field
                                  label="Progresso"
                                  v-model="lancamentoProgressos[index].progresso"
                                  :suffix="'TIPOLOGIA '+item.indicador.tipologia"
                                  filled
                                ></v-text-field>

                              </div>
                            </template>

                          </v-card-text>
                          <v-card-actions>
                            <template v-if="statusLancamento.value === 'AGUARDANDO_CORRECAO'">
                              <v-btn :loading="isFetching" @click="salvar"  block color="warning">
                                Solicitar correções
                              </v-btn>
                            </template>
                            <template v-if="statusLancamento.value === 'MONITORAMENTO_REALIZADO'">
                              <v-btn :loading="isFetching" @click="salvar"  block color="primary">
                                Realizar monitoramento
                              </v-btn>
                            </template>
                          </v-card-actions>

                        </v-card>
                      </v-form>
                    </template>
                  </v-col>

                  <v-col cols="6">
                    <v-card elevation="0" tile>
                      <v-card-title >
                        <p>Arquivos do Lançamento </p>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <ArquivosLancamento :permissao="canEditLancamento" :indicadorId="indicador.id" :lancamento="lancamento"></ArquivosLancamento>                        
                      </v-card-text>
                    </v-card>
                  </v-col>

                </v-row>
              </v-tab-item>

              <v-tab-item :value="'tab-upload'">
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" tile>
                      <v-card-text>
                        <FileBrowser :permissao="canEditLancamento" :projetoId="this.$route.params.projetoId" :root="indicador.itemStorage" :indicador="indicador" :lancamentoId="lancamento.id" />
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="false" :value="'tab-arquivos-lancamento'">
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" tile outlined class="mx-1">
                      <v-card-title >
                        <p>Arquivos do Lançamento</p>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <ArquivosLancamento :permissao="canEditLancamento" :indicadorId="indicador.id" :lancamento="lancamento"></ArquivosLancamento>                        
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="false" :value="'tab-lista-presenca'">
                <ListaPresencaCard :permissao="canEditLancamento" :lancamento="lancamento"></ListaPresencaCard>
              </v-tab-item>
              <v-tab-item v-if="indicador.relatoriaReuniaoEncontro" :value="'tab-relatoria-reuniao-encontro'">
                <RelatoriaReuniaoEncontroCard :permissao="canEditLancamento" :lancamento="lancamento"></RelatoriaReuniaoEncontroCard>
              </v-tab-item>
              <v-tab-item v-if="indicador.planoOficinaIntercambioCaravana" :value="'tab-plano-oficina-intercambio-caravana'">
                <PlanoOficinaIntercambioCaravanaCard :permissao="canEditLancamento" :lancamento="lancamento"></PlanoOficinaIntercambioCaravanaCard>
              </v-tab-item>
              <v-tab-item v-if="indicador.relatoriaOficinaIntercambioCaravana" :value="'tab-relatoria-oficina-intercambio-caravana'">
                <RelatoriaOficinaIntercambioCaravanaCard :permissao="canEditLancamento" :lancamento="lancamento"></RelatoriaOficinaIntercambioCaravanaCard>
              </v-tab-item>
              <v-tab-item v-if="false" :value="'tab-registro-fotografico-modelado'">
                <RegistroFotograficoModeladoCard :permissao="canEditLancamento" :lancamento="lancamento"></RegistroFotograficoModeladoCard>
              </v-tab-item>
              <v-tab-item v-if="indicador.informeReuniao" :value="'tab-informe-reuniao'">
                <InformeReuniaoCard :permissao="canEditLancamento" :lancamento="lancamento"></InformeReuniaoCard>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <Confirm ref="confirm"></Confirm>

  </v-dialog>
</template>

<script>
import Confirm from "@/components/Dialog/Confirm";

import FileBrowser from '@/pages/Projeto/components/FileBrowser/FileBrowser'
import ArquivosLancamento from "@/pages/Projeto/components/Arquivo/ArquivosLancamento"

import ListaPresencaCard from '@/pages/Projeto/components/Formularios/ListaPresenca/ListaPresencaCard'
import PlanoOficinaIntercambioCaravanaCard from '@/pages/Projeto/components/Formularios/PlanoOficinaIntercambioCaravana/PlanoOficinaIntercambioCaravanaCard'
import RegistroFotograficoModeladoCard from '@/pages/Projeto/components/Formularios/RegistroFotograficoModelado/RegistroFotograficoModeladoCard'
import RelatoriaOficinaIntercambioCaravanaCard from '@/pages/Projeto/components/Formularios/RelatoriaOficinaIntercambioCaravana/RelatoriaOficinaIntercambioCaravanaCard'
import RelatoriaReuniaoEncontroCard from '@/pages/Projeto/components/Formularios/RelatoriaReuniaoEncontro/RelatoriaReuniaoEncontroCard'
import InformeReuniaoCard from '@/pages/Projeto/components/Formularios/InformeReuniao/InformeReuniaoCard'
import asyncDataStatus from "@/mixins/asyncDataStatus";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    FileBrowser,
    ArquivosLancamento,
    ListaPresencaCard,
    PlanoOficinaIntercambioCaravanaCard,
    RegistroFotograficoModeladoCard,
    RelatoriaOficinaIntercambioCaravanaCard,
    RelatoriaReuniaoEncontroCard,
    InformeReuniaoCard,
    Confirm
  },
  props: {
    lancamento: {
      require: false
    },
    indicador: {
      require: false
    },
    isPermissao: {
      require: true
    },
  },

  mixins: [asyncDataStatus],

  computed: {
    ...mapState('lancamento', {
      isFetching: state => state.isFetching,
    }),

    lancamentosFilhos() {
      return this.$store.getters["lancamento/byLancamentoPaiId"](this.lancamento.id);
    },

    impacto() {
      return this.logicaIntervencaoByNivel("OBJETIVO_GERAL");
    },
    realizacao() {
      return this.logicaIntervencaoByNivel("OBJETIVO_ESPECIFICO");
    },
    produto() {
      return this.logicaIntervencaoByNivel("RESULTADO_ESPERADO");
    },
    atividade() {
      return this.logicaIntervencaoByNivel("ATIVIDADE");
    },
    formularios() {
      return this.$store.getters["formulario/byLancamentoId"](this.lancamento.id);
    },
    usuario() {
      return this.$store.getters["usuario/getUser"];
    },
    participantes() {
      return this.$store.getters["projeto/getParticipantes"](parseInt(this.$route.params.projetoId));
    },    
    participante() {
      let payload = {
        'projetoId': this.$route.params.projetoId,
        'usuarioId': this.usuario.id
      }
      return this.$store.getters["projeto/participanteAtual"](payload);
    },

    canView() {
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      const usuarioId = this.$store.getters["usuario/getUsuarioAutenticado"].id;

      if(this.indicador.responsavel.id === usuarioId) {
        return true
      }

      if(this.lancamento.lancadoPor.id === usuarioId) {
        return true
      }

      var payload = {
        'permission': ['PERMISSION_INDICADOR_VIEW', 'PERMISSION_LANCAMENTO_FONTE_VIEW', 'PERMISSION_MONITORAMENTO_INDICADOR_VIEW'],
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': usuarioId
      }      
      return this.$store.getters["projeto/hasPermission"](payload);
    },

    canDeleteLancamento() {
      const usuarioId = this.$store.getters["usuario/getUsuarioAutenticado"].id;
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }

      var payload = {
        'papel': 'AGENTE_MONITORAMENTO_PROGRAMATICO',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': usuarioId
      }
      return this.$store.getters["projeto/hasPapel"](payload);
    },

    canEditLancamento() {
      var usuarioId = this.$store.getters["usuario/getUsuarioAutenticado"].id;

      if(this.lancamento.statusLancamento === 'ABERTO' || this.lancamento.statusLancamento === 'AGUARDANDO_CORRECAO') {
        if(this.$store.getters["auth/isAdministrador"]) {
          return true
        }

        if(this.lancamento.lancadoPor.id === this.$store.getters["usuario/getUsuarioAutenticado"].id) {
          return true
        }

      }

      if(this.lancamento.statusLancamento === 'AGUARDANDO_MONITORAMENTO' || this.lancamento.statusLancamento === 'MONITORAMENTO_REALIZADO') {
        if(this.$store.getters["auth/isAdministrador"]) {
          return true
        }

        var payloadCanEditMonitoramento = {
          'papel': 'AGENTE_MONITORAMENTO_PROGRAMATICO',
          'projetoId': parseInt(this.$route.params.projetoId),
          'usuarioId': usuarioId
        }

        return this.$store.getters["projeto/hasPapel"](payloadCanEditMonitoramento);
      }

      if(this.lancamento.statusLancamento === 'AGUARDANDO_MONITORAMENTO' || this.lancamento.statusLancamento === 'MONITORAMENTO_REALIZADO') {
        if(this.$store.getters["auth/isAdministrador"]) {
          return true
        }

        var payload = {
          'papel': 'AGENTE_MONITORAMENTO_PROGRAMATICO',
          'projetoId': parseInt(this.$route.params.projetoId),
          'usuarioId': usuarioId
        }
        return this.$store.getters["projeto/hasPapel"](payload);
      }

      return false
    },

    canEditMonitoramento() {
      if(this.lancamento.statusLancamento === 'AGUARDANDO_MONITORAMENTO' || this.lancamento.statusLancamento === 'MONITORAMENTO_REALIZADO') {
        if(this.$store.getters["auth/isAdministrador"]) {
          return true
        }

        const usuarioId = this.$store.getters["usuario/getUsuarioAutenticado"].id;
        var payload = {
          'permission': ['PERMISSION_MONITORAMENTO_INDICADOR_EDIT'],
          'projetoId': parseInt(this.$route.params.projetoId),
          'usuarioId': usuarioId
        }
        
        return this.$store.getters["projeto/hasPermission"](payload);
      }
      return false
    },
  },

  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
    lancamento() {
      const payload = {'lancamentoId': this.lancamento.id, 'indicadorId': this.indicador.id}
      this.fetchFormularios(payload).then(() => {
        this.asyncDataStatus_fetched();
      });
    },
  },

  data() {
    return {
      lancamentoProgressos: [],
      array:[],
      dialog: false,
      logicaIntervencao: this.indicador.logicaIntervencao,
      selectedItem: 0,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      progresso: this.lancamento.progresso,
      responsavelId: this.lancamento.monitoradoPor ? this.lancamento.monitoradoPor.id : null,

      statusLancamento: {value: this.lancamento.statusLancamento},
      observacoesMonitoramento: this.lancamento.observacoesMonitoramento,

      valid: false,
    };
  },

  methods: {
    salvar () {
      //if(this.$refs.form.validate() && this.progresso > 0) {
      if(this.$refs.form.validate()) {
        const payload = {
          "indicadorId": this.indicador.id,
          "lancamentoId": this.lancamento.id,
          "progresso": this.progresso,
          "responsavelId": this.responsavelId,
          "data": this.date,
          "status": this.statusLancamento.value,
          "observacoes": this.observacoesMonitoramento,
          "lancamentoProgressos": this.lancamentoProgressos,
        }
        console.log(payload)
        this.$store.dispatch('lancamento/realizarMonitoramento', payload)
      }
    },
    enviarParaMonitoramento() {
        const payload = {
          "indicadorId": this.indicador.id,
          "lancamentoId": this.lancamento.id,
        }      
      return this.$store.dispatch('lancamento/enviarParaMonitoramento', payload)
    },     

    logicaIntervencaoByNivel(nivel) {
      switch (nivel) {
        case "OBJETIVO_GERAL":
          if (this.logicaIntervencao.nivel === "OBJETIVO_GERAL") {
            return this.logicaIntervencao;
          }
          break;
        case "OBJETIVO_ESPECIFICO":
          if (this.logicaIntervencao.nivel === "ATIVIDADE") {
            return this.logicaIntervencao.logicaIntervencao.logicaIntervencao;
          } else if (this.logicaIntervencao.nivel === "RESULTADO_ESPERADO") {
            return this.logicaIntervencao.logicaIntervencao;
          } else if (this.logicaIntervencao.nivel === "OBJETIVO_ESPECIFICO") {
            return this.logicaIntervencao;
          }
          break;
        case "RESULTADO_ESPERADO":
          if (this.logicaIntervencao.nivel === "ATIVIDADE") {
            return this.logicaIntervencao.logicaIntervencao;
          } else if (this.logicaIntervencao.nivel === "RESULTADO_ESPERADO") {
            return this.logicaIntervencao.logicaIntervencao;
          }
          break;
        case "ATIVIDADE":
          if (this.logicaIntervencao.nivel === "ATIVIDADE") {
            return this.logicaIntervencao;
          }
          break;
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    ...mapActions("formulario", ["fetchFormularios"]),
    ...mapActions("lancamento", ["deletarLancamento"]),

    // Exluir Lançamento
    excluir() {
      this.$refs.confirm
        .open(
          'Excluir Lançamento',
          '',
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            const payload = { "indicadorId": this.indicador.id, "lancamentoId": this.lancamento.id}
            this.deletarLancamento(payload);
          }
        });
    },


  },
  created() {
    const payload = {'lancamentoId': this.lancamento.id, 'indicadorId': this.indicador.id}
    this.lancamentoProgressos = []
    this.lancamentosFilhos.forEach(filho => {
      this.lancamentoProgressos.push({'lancamentoId': filho.id, 'progresso': filho.progresso})
    });

    Promise.all([
      this.$store.dispatch("usuario/getUsuario"),
      this.fetchFormularios(payload)
    ]).then(() => {
      this.asyncDataStatus_fetched();
    });
  },
};
</script>

<style src="./FonteVerificacaoGerenciamento.scss" lang="scss"/>


